var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 157,
    viewBox: "0 0 145 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddddd_714_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.189 52.2353C136.189 84.6901 109.731 111 77.0943 111C44.4574 111 18 84.6901 18 52.2353C18 19.7804 62.026 3 94.6629 3C127.3 3 136.189 19.7804 136.189 52.2353Z",
    fill: "#F9EEEE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0001 32C70.3972 32 64.3859 34.5709 59.9131 38.7642C59.9102 38.7669 59.9073 38.7697 59.9045 38.7725C59.9035 38.7735 59.9054 38.7715 59.9045 38.7725C55.0431 43.3359 52 49.8189 52 56.9999C52 70.7896 63.2104 82 77.0001 82C83.5517 82 89.5221 79.469 93.9838 75.3335C94.0279 75.3005 94.0701 75.265 94.1102 75.2272C94.1249 75.2112 94.1393 75.1949 94.1533 75.1783C98.9846 70.6175 102.003 64.1554 102.003 56.9998C102.003 49.8487 98.9879 43.393 94.1619 38.8327C94.1452 38.8122 94.128 38.7921 94.1102 38.7724C94.0447 38.7024 93.9726 38.6389 93.8948 38.5829C89.443 34.4969 83.5078 32 77.0001 32ZM75.7536 35.1423V44.5776C73.5653 44.4541 71.4225 44.0079 69.3915 43.2621C69.6844 42.4605 69.9991 41.701 70.3365 40.9988C71.911 37.7217 73.8432 35.7468 75.7536 35.1423ZM78.6948 35.306C80.4617 36.059 82.2252 37.9747 83.6781 40.9988C84.0152 41.7003 84.331 42.4586 84.6231 43.2593C82.7265 43.9556 80.731 44.3927 78.6948 44.5489V35.306ZM69.8741 36.116C69.0609 37.1736 68.3301 38.3936 67.6883 39.7293C67.334 40.4667 67.0025 41.2461 66.6973 42.0615C65.4713 41.4139 64.3032 40.6483 63.2104 39.7724C65.1817 38.1934 67.4311 36.9472 69.8741 36.116ZM84.1406 36.1188C86.5818 36.951 88.8287 38.1991 90.7985 39.7781C89.7071 40.6518 88.5392 41.4152 87.3144 42.0615C87.0093 41.2462 86.6806 40.4666 86.3264 39.7292C85.6852 38.3949 84.9541 37.1757 84.1406 36.1188ZM61.0218 41.7829C62.4926 43.0053 64.0886 44.051 65.7782 44.8993C64.8962 48.0888 64.3644 51.6935 64.2559 55.5353H54.9929C55.3408 50.2116 57.5685 45.4087 61.0218 41.7829ZM92.9814 41.7829C96.4347 45.4087 98.6624 50.2116 99.0103 55.5353H89.7587C89.6501 51.691 89.1137 48.0845 88.2307 44.8936C89.9177 44.0459 91.5126 43.0036 92.9814 41.7829ZM85.4991 46.0683C86.2401 48.8889 86.7066 52.1066 86.8118 55.5353H78.6948V47.4987C81.0321 47.3403 83.3209 46.8553 85.4991 46.0683ZM68.5126 46.0712C70.8263 46.9062 73.2651 47.4004 75.7536 47.5246V55.5353H67.1914C67.2973 52.1077 67.7693 48.8911 68.5126 46.0712ZM54.9929 58.4765H64.2559C64.3651 62.3139 64.8975 65.924 65.7782 69.1125C64.0909 69.9613 62.4967 71.0051 61.0275 72.226C57.5723 68.6016 55.3431 63.7999 54.9929 58.4765ZM67.1914 58.4765H75.7536V66.4757C73.266 66.6004 70.8284 67.0983 68.5155 67.9348C67.7721 65.1166 67.2981 61.9023 67.1914 58.4765ZM78.6948 58.4765H86.8118C86.7059 61.9019 86.2397 65.1168 85.4991 67.9348C83.3206 67.1476 81.0321 66.6601 78.6948 66.5016V58.4765ZM89.7558 58.4765H99.0103C98.6602 63.7971 96.4334 68.5966 92.9814 72.2203C91.5131 71 89.9201 69.9573 88.2335 69.1096C89.1143 65.9212 89.6466 62.3138 89.7558 58.4765ZM75.7536 69.4227V78.8609C73.8432 78.2564 71.911 76.2786 70.3365 73.0015C69.9994 72.3 69.6842 71.5447 69.3915 70.7439C71.4225 69.996 73.5653 69.5468 75.7536 69.4227ZM78.6948 69.4544C80.7308 69.6114 82.7264 70.0485 84.6231 70.7469C84.3313 71.5467 84.0148 72.3008 83.6781 73.0016C82.2252 76.0255 80.4617 77.9413 78.6948 78.6944V69.4544ZM66.6973 71.9475C67.0027 72.7643 67.3336 73.5445 67.6883 74.2826C68.3277 75.6136 69.0558 76.8279 69.8654 77.8816C67.4292 77.0513 65.186 75.8078 63.219 74.2337C64.3095 73.36 65.4743 72.5947 66.6973 71.9475ZM87.3144 71.9504C88.5359 72.5962 89.7011 73.3569 90.7899 74.2281C88.8244 75.8021 86.5838 77.0477 84.1492 77.8787C84.9592 76.8257 85.6875 75.6122 86.3264 74.2826C86.6806 73.5453 87.0093 72.7662 87.3144 71.9504Z",
    fill: "#FF3833"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddddd_714_1118",
    x: 0,
    y: 0,
    width: 144.189,
    height: 157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_1118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_714_1118",
    result: "effect2_dropShadow_714_1118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_714_1118",
    result: "effect3_dropShadow_714_1118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_714_1118",
    result: "effect4_dropShadow_714_1118"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_714_1118",
    result: "effect5_dropShadow_714_1118"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect5_dropShadow_714_1118",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOne);
export default __webpack_public_path__ + "static/media/serviceOne.b7d0ca84e44140975df481905586b664.svg";
export { ForwardRef as ReactComponent };